import React, { useState } from 'react';
import { connect } from 'react-redux';
import { NavLink, useHistory } from 'react-router-dom';
import { RootState } from '../../models/RootState';
import { fetchBalance, logout } from '../../store';
import Modal from '../../components/Modal/LoginModal';
import { CONFIG_PERMISSIONS } from '../../constants/ConfigPermission';
import './SubHeader.scss';
import { Backdrop, Button, Tabs } from '@material-ui/core';
import LoginForm from '../../components/LoginForm/LoginForm';
import { BRAND_NAME } from '../../constants/Branding';

type StoreProps = {
  allowedConfig: number;
  loggedIn: boolean;
  logout: Function;
};

const SubHeader: React.FC<StoreProps> = (props) => {
  const { allowedConfig, loggedIn, logout } = props;
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const modalCloseHandler = () => {
    setModalOpen(false);
  };
  const history = useHistory();
  const pathName = history.location.pathname;
  return (
    <>
      <div className="app-sub-header">
        <Tabs
          value={1}
          variant="scrollable"
          scrollButtons="auto"
          className="actions-list"
        >
          {(allowedConfig & CONFIG_PERMISSIONS.sports) !== 0 ? (
            <>
              <NavLink
                to="/exchange_sports/inplay"
                className={
                  pathName.includes('exchange_sports') &&
                  !pathName.includes('/exchange_sports/multi-markets')
                    ? 'nav-link active'
                    : 'nav-link'
                }
              >
                <Button className="nav-link-btn">exchange</Button>
              </NavLink>

              <NavLink
                to="/exchange_sports/cricket/indian-premier-league/indian-premier-league/NDoxMDE0ODA6MjgxMjczNDg="
                className={
                  pathName.includes('indian-premier-league') 
                    ? 'nav-link color-change active'
                    : 'nav-link color-change'
                }
              >
                <Button className="newlacunch-menu">IPL</Button>
              </NavLink>

              {loggedIn ? (
                <NavLink to="/mo/theme" className="nav-link mob-view">
                  <Button className="newlacunch-menu">
                    <div className="newlacunch-menu">Change Site</div>
                  </Button>
                </NavLink>
              ) : null}

              {loggedIn ? (
                <NavLink
                  to="/exchange_sports/multi-markets"
                  className="nav-link"
                  exact={pathName === '/exchange_sports/multi-markets'}
                >
                  <Button className="nav-link-btn">Multi Markets</Button>
                </NavLink>
              ) : null}
              <NavLink
                className="nav-link"
                aria-disabled="true"
                to={!loggedIn ? '/login' : '/premium_sports'}
              >
                <Button className="nav-link-btn">Sports Book</Button>
              </NavLink>
            </>
          ) : null}

          {(allowedConfig & CONFIG_PERMISSIONS.casino) !== 0 ? (
            <>
              <NavLink
                to="/virtual_games"
                className="nav-link"
                // onClick={() => setModalOpen(true)}
              >
                <Button className="nav-link-btn">Virtual Sports</Button>
              </NavLink>

              <NavLink
                to="/casino"
                className="nav-link"
                // onClick={() => setModalOpen(true)}
              >
                <Button className="nav-link-btn">Live Casino</Button>
              </NavLink>

              <NavLink
                to="/slot_games"
                className="nav-link"
                // onClick={() => setModalOpen(true)}
              >
                <Button className="nav-link-btn">SLots</Button>
              </NavLink>
            </>
          ) : null}
        </Tabs>
      </div>

      <Backdrop className="backdrop-ctn" open={modalOpen}>
        <Modal
          open={modalOpen}
          closeHandler={modalCloseHandler}
          noTitle={true}
          size="xs"
          customClass={'login-modal-ctn'}
        >
          <LoginForm modalCloseHandler={modalCloseHandler}></LoginForm>
        </Modal>
      </Backdrop>
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    allowedConfig: state.common.allowedConfig,
    loggedIn: state.auth.loggedIn,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    fetchBalance: () => dispatch(fetchBalance()),
    logout: () => dispatch(logout()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SubHeader);
